import { useMemo, useState } from 'react';
import { animeList } from '@/mocks/animeData';

const tabs = [
  { key: '全部', label: '全部' },
  { key: '甜番', label: '高甜番' },
  { key: '纯爱', label: '纯爱番' },
  { key: '狗粮', label: '狗粮番' },
  { key: '暧昧', label: '暧昧番' },
];

const categoryColor: Record<string, string> = {
  甜番: 'bg-primary-100 text-primary-700',
  纯爱: 'bg-secondary-100 text-secondary-900',
  狗粮: 'bg-accent-100 text-accent-700',
  暧昧: 'bg-background-200 text-foreground-700',
};

export default function RecommendSection() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? animeList : animeList.filter((a) => a.category === active)),
    [active],
  );

  return (
    <section id="recommend" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
            <i className="ri-heart-3-line"></i>
            本周精选甜番合集
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">心动番剧精选合集</h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            甜度测评 + 心动名场面一键预览，挑一部就能开刷。点击上方分类，快速锁定今天想磕的糖。
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <div className="inline-flex items-center gap-1 bg-background-50 border border-background-200/80 rounded-full p-1 flex-wrap justify-center">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setActive(t.key)}
                className={`px-4 py-2 text-sm rounded-full whitespace-nowrap transition-colors ${
                  active === t.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}恋爱甜番剧照`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span
                  className={`absolute top-3 left-3 px-2 py-1 text-xs font-medium rounded-full ${categoryColor[item.category]}`}
                >
                  {item.category} · {item.status}
                </span>
              </div>

              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950">{item.title}</h3>
                    <p className="text-xs text-foreground-500">{item.titleEn}</p>
                  </div>
                  <span className="px-2 py-1 text-sm font-bold text-primary-700 bg-primary-100 rounded-md whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>

                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-play-list-2-line"></i>
                    {item.episodes}
                  </span>
                  <span>{item.year}</span>
                  <span className="flex items-center gap-0.5 text-primary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className={i < item.sweetness ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                    ))}
                    <em className="not-italic text-foreground-500 ml-1">甜度</em>
                  </span>
                </div>

                <div className="mt-3 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-xs text-secondary-900 bg-secondary-100 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{item.desc}</p>
                <p className="mt-3 flex items-start gap-1.5 text-sm text-accent-700">
                  <i className="ri-lightbulb-flash-line mt-0.5"></i>
                  <span>{item.reason}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}